import { Seaport } from '@opensea/seaport-js'
import { ethers } from 'ethers'

import { display } from '@mui/system'
import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { walletModalhide } from '../../redux/counterSlice'
import { useAppSelector } from '../../redux/hooks'
import { ItemType } from '@opensea/seaport-js/lib/constants'

const Wallet_modal = () => {
	const walletModal = useAppSelector((state) => state.counter.walletModal)
	const dispatch = useDispatch()
	// useEffect(() => {
	// 	const fetch = async () => {
	// 		;(window as any).Seaport = Seaport
	// 		;(window as any).ItemType = ItemType
	// 		;(window as any).ethers = ethers
	// 		const provider = new ethers.providers.Web3Provider((window as any).ethereum)
	// 		await provider.send('eth_requestAccounts', [])
	// 		var seaport = new Seaport(provider, {
	// 			conduitKeyToConduit: {
	// 				'0x0000000000000000000000000000000000000000000000000000000000000000':
	// 					'0x077969d99cAcaD858085115c97415A36885B81Ba',
	// 			},
	// 			overrides: {
	// 				contractAddress: '0x070CaAeac85CCaA7E8DCd88421904C2259Abed34',
	// 				defaultConduitKey: '0x0000000000000000000000000000000000000000000000000000000000000000',
	// 			},
	// 		})
	// 		;(window as any).provider = provider
	// 		;(window as any).seaport = seaport
	// 	}
	// 	fetch()
	// }, [])
	return (
		<div>
			{/* <!-- Wallet Modal --> */}
			<div className={walletModal ? 'block modal fade show ' : 'modal fade hidden'}>
				<div className="modal-dialog max-w-lg">
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title" id="walletModalLabel">
								Connect your wallet
							</h5>
							<button
								type="button"
								className="btn-close"
								onClick={() => dispatch(walletModalhide())}
							>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 24 24"
									width="24"
									height="24"
									className="fill-jacarta-700 h-6 w-6 dark:fill-white"
								>
									<path fill="none" d="M0 0h24v24H0z" />
									<path d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z" />
								</svg>
							</button>
						</div>

						{/* <!-- Body --> */}
						<div className="modal-body p-6 text-center">
							<svg className="icon icon-metamask mb-4 inline-block h-8 w-8">
								<use xlinkHref="/icons.svg#icon-metamask"></use>
							</svg>
							<p className="text-center dark:text-white">
								You {"don't"} have MetaMask in your browser, please download it from
								<a
									href="https://metamask.io/"
									className="text-accent"
									target="_blank"
									rel="noreferrer noopener"
								>
									MetaMask
								</a>
							</p>
						</div>
						{/* <!-- end body --> */}

						<div className="modal-footer">
							<div className="flex items-center justify-center space-x-4">
								<a
									href="https://metamask.io/"
									target="_blank"
									rel="noreferrer noopener"
									className="bg-accent shadow-accent-volume hover:bg-accent-dark rounded-full py-3 px-8 text-center font-semibold text-white transition-all"
								>
									Get Metamask
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Wallet_modal
